import {
    GET_USERS,
    SET_REPORT_TYPE,
    GET_VEHICLE_LIST,
    GET_REPORT_TITLES,
    SET_DATE_FROM,
    SET_DATE_TO,
    GET_TOTAL_USER_REPORTS,
    SET_EXCEL_REPORT_TYPE,
    GET_TOTAL_JOB_PACK_REPORTS,
    GET_EXCEL_REPORT_TYPE_LABELS,
    GET_EXCEL_DOCUMENT_BUILDING,
    GET_EXCEL_DOCUMENT_FINISHED
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import XLSX from "xlsx";

export const getUsers = () => {
    return async dispatch => {
        dispatch({
            type: GET_USERS.REQUEST
        });

        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({ type: GET_USERS.FAIL });
            } else {
                firebase
                    .database()
                    .ref(`/users`)
                    .on("value", snapshot => {
                        if (typeof snapshot.val() !== "undefined") {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        } else {
                            dispatch({ type: GET_USERS.FAIL });
                        }
                    });
            }
        });
    };
};
export const getVehicles = () => {
    return dispatch => {
        dispatch({ type: GET_VEHICLE_LIST.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_VEHICLE_LIST.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/machines")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_VEHICLE_LIST.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_VEHICLE_LIST.FAIL });
        }
    };
};
export const setReportType = report_type => {
    return async dispatch => {
        dispatch({
            type: SET_REPORT_TYPE,
            payload: report_type
        });
    };
};
export const getTotalUserReports = () => {
    return dispatch => {
        dispatch({ type: GET_TOTAL_USER_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_TOTAL_USER_REPORTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("subjects/reports/")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_TOTAL_USER_REPORTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOTAL_USER_REPORTS.FAIL });
        }
    };
};
export const getTotalJobPackReports = () => {
    return dispatch => {
        dispatch({ type: GET_TOTAL_JOB_PACK_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_TOTAL_JOB_PACK_REPORTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("subjects/job_packs/")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_TOTAL_JOB_PACK_REPORTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TOTAL_JOB_PACK_REPORTS.FAIL });
        }
    };
};
export const getReportTitles = () => {
    return dispatch => {
        dispatch({
            type: GET_REPORT_TITLES.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT_TITLES.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/report_titles")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT_TITLES.FAIL
            });
        }
    };
};
export const setDateFrom = from => {
    return dispatch => {
        dispatch({ type: SET_DATE_FROM, payload: from });
    };
};
export const setDateTo = to => {
    return dispatch => {
        dispatch({ type: SET_DATE_TO, payload: to });
    };
};

export const setExcelReportType = reportType => {
    return dispatch => {
        dispatch({ type: SET_EXCEL_REPORT_TYPE, payload: reportType });
    };
};
export const getExcelReportTypeLabels = reportType => {
    return dispatch => {
        dispatch({
            type: GET_EXCEL_REPORT_TYPE_LABELS.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_EXCEL_REPORT_TYPE_LABELS.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(`collections/report_keys/${reportType}`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_EXCEL_REPORT_TYPE_LABELS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_EXCEL_REPORT_TYPE_LABELS.FAIL
            });
        }
    };
};
export const getExcelDoc = (userReports, reportType) => {
    return (dispatch, getStore) => {
        let labels = getStore().Dashboard_reducer.reportExcelLabels;
        dispatch({ type: GET_EXCEL_DOCUMENT_BUILDING });

        if (Array.isArray(userReports[0])) {
            userReports.unshift(labels);
            const ws_name = `${reportType}`;

            const fileName = `${reportType}-report.xlsx`;

            const wb = XLSX.utils.book_new();
            let ws = wb.Sheets[wb.SheetNames[0]];
            ws = XLSX.utils.aoa_to_sheet(userReports);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);

            XLSX.writeFile(wb, fileName);
        } else {
            userReports.forEach(e => {
                Object.keys(e).map(key => {
                    delete Object.assign(e, { [labels[key]]: e[key] })[key];
                    return true;
                });
            });
            const ws_name = `${reportType}`;

            const fileName = `${reportType}-report.xlsx`;

            const wb = XLSX.utils.book_new();
            let ws = wb.Sheets[wb.SheetNames[0]];
            ws = XLSX.utils.json_to_sheet(userReports);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);

            XLSX.writeFile(wb, fileName);
        }
        dispatch({ type: GET_EXCEL_DOCUMENT_FINISHED });
    };
};
